module.exports = __webpack_public_path__ + "static/media/lsk.aab8a26a.svg";